import React, { Component } from 'react';
import LatestLivestream from './LatestLivestream.js';
import FeaturedLivestreams from './FeaturedLivestreams.js';

class RecentLivestreams extends Component {
  constructor(props) {
    super(props);

    // TODO lots of hard coded data to keep up to date
    this.state = {
      featuredLivestreams: [
        {
          "creatorAddress": "0x93bb3dc705fb2ad98b696bcc17a0fb7d439d12f4",
          "creatorImage": "https://pbs.twimg.com/profile_images/1480561258759917570/9x2dEZ63_400x400.jpg",
          "creatorName": "Alara",
          "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmdisAfqzLJAV5xu95hFLqHcZUQBJ4oMrqf75nTWVsaB75.png",
          "itemName": "Greenpoint",
          "itemRoute": "/profile/alara"
        },
        {
          "creatorAddress": "0x0f1af0576ea168db8b1d4775589b762124ec3c4a",
          "creatorImage": "https://pbs.twimg.com/profile_images/1543145178910818304/AFcbPH6c_400x400.jpg",
          "creatorName": "Ahmed Kazmi",
          "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmfY1k7h5As8htvwV2hSn36nK3S2WQnEeHe7A9uBcPpSMH.png",
          "itemName": "Missing Things I Never Tried | DEMOS",
          "itemRoute": "/profile/ahmedkazmi"
        },
        {
          "creatorAddress": "0xf873e05c28be2845f09c828dae42084b6b1c060e",
          "creatorImage": "https://pbs.twimg.com/profile_images/1546713666518765569/G6hdGIBv_400x400.jpg",
          "creatorName": "Dom Deshawn",
          "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmSCwuTv4qCf43FJNExHUSTjvJvadw81y5W7PHMdVwm6Tw.png",
          "itemName": "Last Night of Summer",
          "itemRoute": "/profile/domdeshawn"
        },
        {
          "creatorAddress": "0xd8f5ba4b9b6f29b9b4aca3cdc3b46bf5bcc9b7ed",
          "creatorImage": "https://static-cdn.jtvnw.net/jtv_user_pictures/efc72373-8f2b-4499-9614-ff66011f7a4f-profile_image-70x70.png",
          "creatorName": "Mike Bass",
          "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmZgm2eRohBfun4vrkc8KdbcyuCKtBbWyokZDfT1f6FLXp.png",
          "itemName": "Live at the402 - September 27, 2022",
          "itemRoute": "/profile/mikebass"
        },
        {
          "creatorAddress": "0xc4e6c0f61a2b2353e66e0f694de87619b129ef65",
          "creatorImage": "https://pbs.twimg.com/profile_images/1521974291419521025/c67BMSZV_400x400.jpg",
          "creatorName": "Taylor Alexander",
          "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/imageedit_12_8076142783.gif",
          "itemName": "One Voice ft. Emma Miller",
          "itemRoute": "/profile/tayloralexander"
        },
        {
          "creatorAddress": "0x40d65ec8870d0fca1197593291f873fb0b3787db",
          "creatorImage": "https://i.scdn.co/image/ab6761610000e5eb1562c90aa8c10e245b44b857",
          "creatorName": "Emma Miller",
          "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/imageedit_8_8507781346.jpg",
          "itemName": "One Voice ft. Emma Miller",
          "itemRoute": "/profile/emmamiller"
        },
      ],
    }
  }

  render() {
    return (
      <div>
        <div className="justify-center">
          <div className="text-gray-800 dark:text-white font-bold text-md mt-8">
            Recent livestreams
          </div>
          <FeaturedLivestreams
            address={this.props.address}
            featuredLivestreams={this.state.featuredLivestreams}
            selectItemForSubscribe={this.props.selectItemForSubscribe}
            subscriberStatuses={this.props.subscriberStatuses}
          />
        </div>
      </div>
    );
  }
}

export default RecentLivestreams;
